import { IconButton, Tooltip } from '@chakra-ui/react';
import { ReactComponent as DuplicateIcon } from 'assets/icons/duplicate.svg';
import { NODE_CREATED } from 'constants/mixpanel';
import { Mixpanel } from 'libs/third-party/Mixpanel/mixpanel';
import { duplicateActiveWidgets } from 'modules/Editor/Editor.helpers';
import { store, useAppSelector } from 'modules/Editor/store';
import { selectActiveWidgets, selectHasActiveWidget } from 'modules/Editor/store/widgetSelector';
import { Keyboard } from 'modules/common/components/Keyboard';
import { useTranslation } from 'react-i18next';
import { lineConnectionCache } from 'widgets/sdk/LineConnectionCache';

export const DuplicateMenu = () => {
  const { t } = useTranslation('editor_toolbar', { useSuspense: false });
  const isDisabled = !useAppSelector(selectHasActiveWidget);
  const label = t('duplicate');

  const onDuplicate = () => {
    duplicateActiveWidgets();

    const activeWidgets = selectActiveWidgets(store.getState());
    const isMultiSelect = activeWidgets.length > 1;
    if (isMultiSelect) {
      return;
    }

    const activeWidget = activeWidgets[0];
    if (!activeWidget) return;

    const { id, groupId, responsiveGroupId } = activeWidget;
    const isFlowWidget = lineConnectionCache.isConnected(groupId || responsiveGroupId || id);
    if (isFlowWidget) {
      Mixpanel.track(NODE_CREATED.eventName, {
        from: NODE_CREATED.from.Duplication,
      });
    }
  };

  return (
    <Tooltip
      hasArrow
      placement='bottom'
      label={
        <>
          {label} <Keyboard shortcut={['ctrl', 'D']} macOs={['⌘', 'D']} />
        </>
      }
      bg='black'
    >
      <IconButton
        isDisabled={isDisabled}
        size='sm'
        variant={'ghost-with-active'}
        aria-label={label}
        icon={<DuplicateIcon />}
        onClick={onDuplicate}
      />
    </Tooltip>
  );
};
